import React from "react";
import "./App.css";
import IVSPlayer from "./IVSPlayer";

function App() {
  return (
    <div className="App">
      <h1>IVS Player with local SW</h1>
      <IVSPlayer />
    </div>
  );
}

export default App;
